import { GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { destroyUserCountsManager, createUserCountsManager, userCounts, useCachedUserCounts } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/super_sidebar/user_counts_manager.js?vue3';
import { fetchUserCounts } from '~/super_sidebar/user_counts_fetch';
import { issuesDashboardPath, dashboardTodosPath, mergeRequestsDashboardPath } from '~/lib/utils/path_helpers/dashboard';
import Counter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/super_sidebar/components/counter.vue?vue3';
export default {
    name: 'UserCounts',
    components: {
        Counter
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        sidebarData: {
            type: Object,
            required: true
        }
    },
    i18n: {
        mergeRequests: __('Merge requests'),
        todoList: __('To-do items'),
        workItems: __('Assigned work items')
    },
    computed: {
        userCounts () {
            return userCounts;
        },
        mergeRequestsDashboardPath () {
            return mergeRequestsDashboardPath({
                organizationPath: null
            });
        },
        dashboardTodosPath () {
            return dashboardTodosPath({
                organizationPath: null
            });
        }
    },
    created () {
        Object.assign(userCounts, this.sidebarData.user_counts);
        createUserCountsManager();
        if (userCounts.assigned_merge_requests === null || userCounts.review_requested_merge_requests === null) {
            useCachedUserCounts();
            fetchUserCounts();
        }
    },
    beforeDestroy () {
        destroyUserCountsManager();
    },
    methods: {
        issuesPathWithUser () {
            return issuesDashboardPath({
                assignee_username: this.sidebarData.username,
                organizationPath: null
            });
        }
    }
};
